module.exports = __webpack_public_path__ + "img/6.66b0aa12.png";